import { ApiAreaOfFocus } from 'api/types/ApiAreaOfFocus';
import { ApiJobFunction } from 'api/types/ApiJobFunction';
import { ApiJobSynonymFamilyId } from 'api/types/ApiTypedId';
import { ListingType } from 'types/ListingType';

type Args = {
  type?: ListingType;
  jobFunction?: ApiJobFunction[];
  areaOfFocus?: ApiAreaOfFocus[];
  familyId?: ApiJobSynonymFamilyId;
};

export function searchAlgoliaGetSearchFiltersStringFromObject({
  type,
  jobFunction,
  areaOfFocus,
  familyId,
}: Args) {
  return [
    type && `type:'${type}'`,
    jobFunction && `(functions:'${jobFunction}')`,
    areaOfFocus && `(areasOfFocus: '${areaOfFocus}')`,
    familyId && `(compdb.familyId:'${familyId}')`,
  ]
    .filter(Boolean)
    .join(' AND ');
}
